import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs';

import { setProject } from '../../core/store';
import { PermissionRequester } from '../../requesters';
import { ProjectAdapter } from '../project.adapter';
import {
	fetchUserPermissionsForProjectFail,
	fetchUserPermissionsForProjectSuccess,
} from './permission.actions';

@Injectable()
export class PermissionEffects {
	// ##########################################################
	// Business Effects
	// ##########################################################

	public getUserPermissionsForProject$ = createEffect(() =>
		this.action$.pipe(
			ofType(setProject),
			switchMap(() =>
				this.permissionRequester.getCurrentUserGlobalPermissions()
			),
			map((result) =>
				fetchUserPermissionsForProjectSuccess({
					permissions: this.adapter.generatePermissions(result),
				})
			),
			catchError((error: HttpErrorResponse, caught) => {
				console.error(error);
				this.store.dispatch(
					fetchUserPermissionsForProjectFail({
						error,
					})
				);
				return caught;
			})
		)
	);

	public constructor(
		private readonly action$: Actions,
		private readonly store: Store,
		private readonly permissionRequester: PermissionRequester,
		private readonly adapter: ProjectAdapter
	) {}
}
